import { Channel } from '@nemuru-eng/js-api-client';
import { SWRConfig } from 'swr';
import { ZodSchema } from 'zod';

import { UserCredentialsActionDialog } from '@/components/modules/Users/components/AddNewUser/components/UserCredentialsActionDialog/UserCredentialsActionDialog';
import { AddNewAdminSchema } from '@/components/modules/Users/schemas/addNewAdmin.schema';
import { AddNewAgentSchema } from '@/components/modules/Users/schemas/addNewAgent.schema';
import { UserCredentialsType } from '@/components/modules/Users/types/UserCredentials';
import { CreateChannelSchema } from '@/components/shared/components/CreateChannelDialog/schema/CreateChannelSchema';
import { FormWrapper } from '@/components/shared/components/FormWrapper';
import { Icon } from '@/components/shared/components/Icon';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { useUserContext } from '@/contexts/UserContext/UserContext';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface AddNewUserProps {
  type: UserCredentialsType;
  disabled?: boolean;
  selectedChannel?: Channel;
}
export const AddNewUser = ({ type, selectedChannel, disabled }: AddNewUserProps) => {
  const { opened, setOpened, toggleDialog } = useDialog();
  const { palette } = useCustomTheme();
  const { userEntity } = useUserContext();

  const addUserParams = {
    [UserCredentialsType.AGENT]: {
      buttonTitle: 'CREATE_NEW_AGENT',
      formSchema: AddNewAgentSchema,
    },
    [UserCredentialsType.ADMIN]: {
      buttonTitle: 'CREATE_NEW_ADMIN',
      formSchema: AddNewAdminSchema,
    },
    [UserCredentialsType.CHANNEL]: {
      buttonTitle: 'CREATE_NEW_CHANNEL',
      formSchema: CreateChannelSchema,
    },
  };

  const addActionParams = addUserParams?.[type];
  const merchantId = userEntity?.merchant?.id;

  return (
    <>
      <StandardButton
        main
        size={'small'}
        color="secondary"
        disabled={disabled}
        onClick={() => setOpened(true)}
        startIcon={<Icon>add</Icon>}
      >
        <Text tId={addActionParams.buttonTitle} />
      </StandardButton>
      {opened && addActionParams && merchantId && (
        <SWRConfig value={{ revalidateOnMount: false }}>
          <FormWrapper formSchema={addActionParams.formSchema as unknown as (t: GetTextIdTranslationType) => ZodSchema}>
            <UserCredentialsActionDialog
              opened={opened}
              setOpened={setOpened}
              toggleDialog={toggleDialog}
              credentialsType={type}
              selectedChannel={selectedChannel}
            />
          </FormWrapper>
        </SWRConfig>
      )}
    </>
  );
};
